module.exports = __webpack_public_path__ + "img/pain_campagne_whole_done.0961ee24.jpg";